
import { NgClass } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ResponsiveDesktopContainerComponent } from "@app/components/responsive-desktop-container/responsive-desktop-container.component";
import { HeaderComponent } from "@app/public/header/header.component";
import { LoadingComponent } from "@commonComponents/loading/loading.component";
import { animationFrameHelper } from "@commonHelpers/animation-frame-helper";
import { delayHelper } from "@commonHelpers/delay-helper";
import { isNullish } from "@commonHelpers/math-utils";
import { NgbModal, NgbModalOptions } from "@commonNodeModules/@ng-bootstrap/ng-bootstrap";
import { LogoService } from "@commonServices/logo.service";
import { CatalogContentType, CatalogNavigationContentType } from "@enums/CatalogContentType";
import { BreadcrumbType } from "@enums/breadcrumbType";
import { CatalogDetailsType } from "@enums/catalog-details-type";
import { CatalogSearchResultDisplayType } from "@enums/catalog-search-result-display-type";
import { ViewType } from "@enums/view-type";
import { environment } from "@environments/environment";
import { CatalogIntegrationCatalogViewerDto, CatalogIntegrationType, CatalogLanguage, CatalogStateEnum, CatalogViewCatalogInformationDto, CatalogViewForeignLanguageCatalogsDto, CatalogViewRelatedCatalogsDto, ContactFormType, FeatureToggleValuesDto, NotificationLanguage } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { Client as SearchAPI, SearchFilterId } from "@interfaces/HttpClient/SearchApiModels";
import { IBreadcrumb } from "@interfaces/iBreadcrumb";
import { ICatalogQueryParams, ICatalogRoutingParams } from "@interfaces/iCatalogRoutingParams";
import { IContactFormOpen } from "@interfaces/iContactFormOpen";
import { TagModel } from "@interfaces/iTagFilter";
import { BreadcrumbService } from "@services/breadcrumb.service";
import { CatalogIntegrationSettingsService } from "@services/catalog-integration-settings.service";
import { CatalogTreeService } from "@services/catalog-tree.service";
import { CatalogViewService } from "@services/catalog-view.service";
import { ComponentScrollService } from "@services/component-scroll.service";
import { NewNewsService } from "@services/new-news.service";
import { NoResultService } from "@services/no-result.service";
import { CatalogSearchresultModel, SearchResultService } from "@services/search-result.service";
import { SearchService } from "@services/search.service";
import { SearchbarService } from "@services/searchbar.service";
import { TranslationService } from "@services/translation.service";
import { Subscription, interval } from "rxjs";
import { takeWhile } from "rxjs/operators";
import { FooterComponent } from "../../../components/footer/footer.component";
import { CatalogNotFoundComponent } from "../../errorpages/catalog-not-found/catalog-not-found.component";
import { CatalogDesktopNavigationComponent } from "../catalog-desktop-navigation/catalog-desktop-navigation.component";
import { CatalogDetailsComponent } from "../catalog-details/catalog-details.component";

@Component({
    selector: "app-catalog-desktop",
    templateUrl: './catalog-desktop.component.html',
    styleUrls: ['./catalog-desktop.component.scss', '../resize-toggle-button.scss'],
    providers: [
        BreadcrumbService,
        CatalogViewService,
        CatalogTreeService,
        SearchResultService,
        SearchbarService,
        SearchService,
        {
            provide: SearchAPI,
            useFactory: (http: HttpClient) => new SearchAPI(http, environment.searchApi),
            deps: [HttpClient]
        }
    ],
    imports: [
        NgClass,
        ResponsiveDesktopContainerComponent,
        HeaderComponent,
        CatalogDetailsComponent,
        LoadingComponent,
        CatalogDesktopNavigationComponent,
        FooterComponent,
        CatalogNotFoundComponent
    ]
})


export class CatalogDesktopComponent implements OnInit, OnDestroy {
	IsNullish = isNullish

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private translationService: TranslationService,
		private breadCrumbService: BreadcrumbService,
		private modalService: NgbModal,
		private catalogViewService: CatalogViewService,
		private titleService: Title,
		private catalogTreeService: CatalogTreeService,
		private searchResultService: SearchResultService,
		private meta: Meta,
		private searchbarService: SearchbarService,
		private searchService: SearchService,
		private noResultService: NoResultService,
		private catalogIntegrationSettingsService: CatalogIntegrationSettingsService,
		private newNewsService: NewNewsService,
		private elRef: ElementRef,
		private componentScrollService: ComponentScrollService,
		private logoService: LogoService
	) {
	}

	public integrationSettings: CatalogIntegrationCatalogViewerDto
	public catalogIntegrationType: CatalogIntegrationType
	public CatalogIntegrationType = CatalogIntegrationType
	public isInIntegrationMode = false;
	private lastCatalogKey: string;
	public catalog: CatalogViewCatalogInformationDto;
	public validCatalog = true;
	public catalogKey: string;
	public url: string;
	public catalogStatePendingPublish = CatalogStateEnum.PendingPublish;
	public searchResultDisplayType = CatalogSearchResultDisplayType;
	private catalogIntegrationSettingsSubscription: Subscription;
	private catalogIntegrationTypeSubscription: Subscription;
	public catalogDetailsType = CatalogDetailsType.Public;
	public catalogContentType = CatalogContentType;
	public catalogNavigationContentType = CatalogNavigationContentType;
	public static nodeIsFolder: boolean;
	private noResultSubscription: Subscription
	public catalogEmptyKey = "waiting";
	public categoriesText: string;
	public catalogRoutingParams: ICatalogRoutingParams;
	public catalogQueryParams: ICatalogQueryParams;
	public breadcrumbs: IBreadcrumb[] = [];
	public rootLink;
	public headerQueryParams;
	public catalogHeaderSelected = true;
	public categoryGroups: { title: string, id: number }[]
	public languageCatalogs: CatalogViewForeignLanguageCatalogsDto[];
	public relatedCatalogs: CatalogViewRelatedCatalogsDto[];
	public featureToggles: FeatureToggleValuesDto;
	private indexDirty = false;
	private resizeObserverHeader: ResizeObserver;
	private resizeObserverNavbar: ResizeObserver;
	private routeSubscription: Subscription;
	private queryParamSubscription: Subscription;
	private catalogSearchChangedSubscription: Subscription;
	public titleToolTip;
	public categoryTooltip;
	public minimizedFilter = false;
	public minimizedDetails = false;
	public activeTab;
	public autoFilterResizing = true;
	public searchFilterId = SearchFilterId;
	public defaultTags: TagModel[];
	public selectedTags: TagModel[];
	public tags: TagModel[];
	public catalogSearchResultModel: CatalogSearchresultModel = { catalogFilterEntries: [], displayType: CatalogSearchResultDisplayType.Catalog, isEmptySearch: false, searchTags: [] };
	@ViewChild("catalogDetails") catalogDetails: CatalogDetailsComponent;

	async ngOnInit() {
		this.searchbarService.searchTerm = "";
		await this.newNewsService.initDb();

		this.routeSubscription = this.route.params.subscribe(async params => {
			this.url = this.router.url;
			this.catalogRoutingParams = params;
			this.meta.updateTag({ name: 'image', content: this.logoService.getLargeLogosByKey(this.catalogRoutingParams.key)?.optimizedSrc });
			this.catalogHeaderSelected = this.catalogRoutingParams.catalogItemGuid === undefined;
			// load catalog only when id has changed
			if (params.key !== this.lastCatalogKey) {
				this.lastCatalogKey = params.key;
				this.catalogKey = params.key;
				await this.loadCatalog(this.catalogKey);
				await this.catalogViewService.getAttachmentTags(this.catalogKey).then(attachmentTags => {
					this.defaultTags = attachmentTags?.map(t => ({ displaystring: t.titleResourceKey, id: t.id }));
					if (this.indexDirty) {
						this.tags = this.defaultTags;
						this.setTabQueryParams();
					}
				});
			}
			if (this.catalogRoutingParams.view !== 'search') {
				this.tags = this.defaultTags;
				this.catalogSearchResultModel.catalogFilterEntries = [];
				this.catalogSearchResultModel.searchTags = [];
				this.searchbarService.insertSearchInput();
				this.searchbarService.searchTerm = '';
				this.indexDirty = false;
			}
			if (!isNullish(this.catalog)) {
				if (isNullish(params.catalogItemGuid)) {
					this.titleService.setTitle(this.translationService.getByKey("browsertab.catalog-view", { name: this.catalog.title }));
					this.meta.updateTag({ name: 'title', content: this.catalog.title });
					this.meta.updateTag({ name: 'description', content: this.catalog.catalogMetaDescription });
				} else {
					void await this.catalogViewService.getCatalogItemMeta(params.catalogItemGuid).then(catalogItemMetaData => {
						if (!isNullish(catalogItemMetaData) && this.route.snapshot.params.catalogItemGuid === catalogItemMetaData.guid) {
							const title = catalogItemMetaData.title;
							this.titleService.setTitle(`${this.catalog.title} - ${title}`);
							this.meta.updateTag({ name: 'title', content: title });
							this.meta.updateTag({ name: 'description', content: catalogItemMetaData.description });
						}
					});

				}
			}
		});

		this.queryParamSubscription = this.route.queryParams.subscribe(async query => {
			this.catalogQueryParams = query;
			this.setTabQueryParams();
			this.catalogHeaderSelected = this.catalogRoutingParams?.catalogItemGuid === undefined;
			this.rootLink = this.getRootLink();
		});
		this.catalogSearchChangedSubscription = this.searchResultService.catalogSearchChanged.subscribe(searchModel => {
			if (!isNullish(searchModel)) {
				this.indexDirty = searchModel.indexDirty;
				this.tags = searchModel.indexDirty ? this.defaultTags : searchModel.searchTags;
				this.catalogSearchResultModel = searchModel;
			} else {
				this.tags = this.defaultTags;
			}
			this.setTabQueryParams();
		})

		this.resizeObserverHeader = new ResizeObserver(entries => {
			animationFrameHelper(entries, () => {
				for (const entry of entries) {
					const textElement = entry.target.querySelector('#titleText') as HTMLElement;
					const categoryElement = entry.target.querySelector('#titleCategoryText') as HTMLElement;
					const onlineHeightText = 30
					// Zeilenanzahl im Header je nach Headerbreite
					if (!isNullish(textElement) && !isNullish(categoryElement)) {
						if (textElement.scrollHeight < onlineHeightText) {
							categoryElement.classList.remove('one-line');
							categoryElement.classList.add('two-lines');
						} else {
							categoryElement.classList.add('one-line');
							categoryElement.classList.remove('two-lines');
						}
						// Tooltips setzen
						this.titleToolTip = textElement.offsetHeight < textElement.scrollHeight ? this.catalog.title : undefined;
						this.categoryTooltip = categoryElement.offsetHeight < categoryElement.scrollHeight ? this.categoriesText : undefined;
					}
				}
			})

		})

		this.resizeObserverNavbar = new ResizeObserver(entries => {
			if (this.autoFilterResizing) {
				animationFrameHelper(entries, () => {
					for (const entry of entries) {
						const element = entry.target
						// Ausblenden der Navigation je nach Breite
						if (!isNullish(element)) {
							this.minimizedFilter = element.scrollWidth < 1200 ? true : false;
						}
					}
				})
			}
		})



		this.noResultSubscription = this.searchResultService.catalogTriggerSearchNoResultTrigger.subscribe(async resultData => {
			if (isNullish(this.catalog)) {
				await interval(100).pipe(takeWhile(() => isNullish(this.catalog)))
					.toPromise()
			}
			const catalogHits = resultData.searchResult?.filterDisplayInfos?.find(fd => fd.filterId === SearchFilterId.Catalog)?.filterEntries;
			if (resultData.refresh) {
				this.searchbarService.searchTerm = '';
				await this.searchResultService.navigate(this.searchService, this.router, this.catalogSearchResultModel.displayType, { key: this.catalogKey }, this.selectedTags, true)
			}
			let catalogKey = this.catalogKey;
			let catalogName = this.catalog.title
			let relatedCatalogs = this.relatedCatalogs;
			const language = this.catalog.language === CatalogLanguage.German ? NotificationLanguage.German : NotificationLanguage.English;
			// Sonderfall: Suche in der Inkatalogsuche bei Auswahl der Suche über einen anderen Katalog
			if ((!isNullish(resultData.catalogKey)) && resultData.catalogKey !== this.catalogKey) {
				catalogKey = resultData.catalogKey;
				relatedCatalogs = await this.catalogViewService.getRelatedCatalogs(catalogKey);
				catalogName = this.relatedCatalogs.find(related => related.key === catalogKey)?.title;
			}
			this.noResultService.open({ searchTerm: resultData.searchTerm, searchFilter: this.route.snapshot.queryParams.searchFilter, centered: false, catalogKey, catalogName, catalogHits, relatedCatalogs, disableGlobalSearch: !this.integrationSettings?.canNavigateToStartingPage, language, searchingType: resultData.searchResult?.searchingType })
		})


		// Website-Integration: Integrationstyp und -Settings aus zentralem Service laden, um Katalogansicht entsprechend der Integration-Use Cases konfigurieren zu können.
		this.catalogIntegrationSettingsSubscription = this.catalogIntegrationSettingsService.settings$.subscribe(settings => {
			this.integrationSettings = settings
			if (this.integrationSettings.collapseNavigation) {
				this.minimizedFilter = true;
				this.autoFilterResizing = false;
				this.resizeObserverNavbar?.disconnect();
			}
		})

		this.catalogIntegrationTypeSubscription = this.catalogIntegrationSettingsService.catalogIntegrationType$.subscribe(catalogIntegrationType => {
			this.catalogIntegrationType = catalogIntegrationType
			this.isInIntegrationMode = !isNullish(this.catalogIntegrationType) && this.catalogIntegrationType !== CatalogIntegrationType.None
		})
	}

	async ngOnDestroy() {
		this.noResultSubscription?.unsubscribe();
		this.catalogIntegrationSettingsSubscription?.unsubscribe();
		this.catalogIntegrationTypeSubscription?.unsubscribe();
		this.routeSubscription?.unsubscribe();
		this.queryParamSubscription?.unsubscribe();
		this.catalogSearchChangedSubscription?.unsubscribe();
		this.resizeObserverHeader?.disconnect();
		this.resizeObserverNavbar?.disconnect();
	}

	private setTabQueryParams() {
		if (isNullish(this.catalogQueryParams?.searchResultDisplayType)) {
			this.tags = this.defaultTags;
			this.selectedTags = [];
		} else if (this.catalogQueryParams?.searchFilter) {
			const selectedTagIds = this.catalogQueryParams?.searchFilter?.substring(3).split('|') ?? [];
			this.selectedTags = this.tags?.filter(t => selectedTagIds.indexOf(t.id + '') >= 0) ?? [];
		} else {
			this.selectedTags = [];
		}
	}


	public async resetFilter() {
		await this.searchResultService.navigate(this.searchService, this.router, this.catalogSearchResultModel.displayType, this.catalogRoutingParams, this.selectedTags, true);
	}

	async openContactForm(item: IContactFormOpen) {
		const catalogInfoOrPosition = this.catalogRoutingParams.catalogItemGuid ? this.catalogDetails.currentMainAttachment?.title : this.translationService.getByKey('catalog-view.roottitle');
		const options: NgbModalOptions = {
			backdrop: 'static',
			modalDialogClass: 'contact-form'
		};
		const contactForm = (await import('@app/components/contact-form/contact-form.component')).ContactFormComponent
		const modalRef = this.modalService.open(contactForm, options);
		modalRef.componentInstance.catalog = this.catalog;
		modalRef.componentInstance.catalogItemGuid = this.catalogRoutingParams.catalogItemGuid ? this.catalogRoutingParams.catalogItemGuid : undefined;
		modalRef.componentInstance.catalogInfoOrPosition = catalogInfoOrPosition;
		if (!isNullish(item.personId)) {
			modalRef.componentInstance.contactPersonId = item.personId;
		}
		modalRef.componentInstance.type = isNullish(this.catalogRoutingParams.catalogItemGuid) ? item.contactFormType : ContactFormType.CatalogItemContact;
	}

	public get hasTree() {
		return this.catalogTreeService.hasTree();
	}

	async loadCatalog(catalogKey: string) {
		this.catalog = undefined;
		this.catalogTreeService.setKey(catalogKey);
		const catalog = await this.catalogViewService.getCatalogInformation(catalogKey);

		if (!catalog) {
			this.validCatalog = false;
			return;
		}
		void this.catalogViewService.getForeignLanguageCatalogs(catalogKey).then(catalogs => this.languageCatalogs = catalogs);
		void this.catalogViewService.getRelatedCatalogs(catalogKey).then(catalogs => this.relatedCatalogs = catalogs);
		await this.translationService.switchCatalogLanguage(catalog.language);
		this.catalog = catalog;


		this.categoryGroups = catalog.categoryGroupIds.map(groupId => ({
			title: this.translationService.getByKey("categories.categoryGroup" + groupId),
			id: groupId
		}));
		this.categoriesText = Object.keys(catalog.categoryResourceKeys)
			.map(categoryResourceKey => catalog.categoryResourceKeys[categoryResourceKey]
				.map(resourceKey => this.translationService.getByKey(resourceKey))
				.join(", ")).join(" | ");
		this.featureToggles = catalog.featureToggles;

		this.createBreadCrumbs();
		this.observeHeader();
		this.observeNavbar();
		// Workaround für ngx-translateBug
		delayHelper(async () => this.translationService.switchCatalogLanguage(this.catalog.language))
	}

	private observeHeader() {
		delayHelper(() => {
			const headerElement = this.elRef.nativeElement.querySelector('#titleTextHeader')
			if (!isNullish(headerElement)) {
				this.resizeObserverHeader?.unobserve(headerElement);
				this.resizeObserverHeader?.observe(headerElement);
			}
		});
	}
	private observeNavbar() {
		delayHelper(() => {
			const catalogWrapperElement = this.elRef.nativeElement.querySelector('#catalogwrapper')
			if (!isNullish(catalogWrapperElement)) {
				this.resizeObserverNavbar?.unobserve(catalogWrapperElement);
				this.resizeObserverNavbar?.observe(catalogWrapperElement);
			}
		});
	}

	public getRootLink() {
		let defaultRootLink = ['/catalog', this.catalogKey];
		if (this.catalogRoutingParams?.view) {
			defaultRootLink = defaultRootLink.concat([this.catalogRoutingParams?.view]);
		}
		return defaultRootLink;
	}

	public async tagNavigation(tags: TagModel[]) {
		await this.searchResultService.navigate(this.searchService, this.router, this.catalogSearchResultModel.displayType, this.catalogRoutingParams, this.selectedTags, false, tags);
	}

	public async clearSearch() {
		let link = ['/catalog', this.catalogKey];
		if (this.catalogRoutingParams.catalogItemGuid) {
			link = link.concat(['catalogItem', this.catalogRoutingParams.catalogItemGuid]);
			if (this.catalogRoutingParams.attachmentId) {
				link = link.concat(['attachment', this.catalogRoutingParams.attachmentId]);
			}
		}
		if (this.catalogQueryParams.searchFilter) {
			link.push('search');
			await this.router.navigate(link, { queryParamsHandling: 'merge', queryParams: { searchTerm: undefined } });
		} else {
			await this.router.navigate(link, { queryParamsHandling: 'merge', queryParams: { searchTerm: undefined, searchPage: undefined, searchResultDisplayType: undefined } });
		}
	}

	private createBreadCrumbs() {
		this.breadcrumbs = [this.breadCrumbService.getStartpage()];

		const cachedNavigations: IBreadcrumb[] = [this.breadCrumbService.getSearchNavigation(), this.breadCrumbService.getCatalogNavigation()];

		if (this.breadCrumbService.getSearchNavigation()) {
			this.breadcrumbs.push(this.breadCrumbService.getSearchNavigation());
		}

		if (this.breadCrumbService.getCatalogNavigation()) {
			this.breadcrumbs.push(this.breadCrumbService.getCatalogNavigation());
		}

		if (!cachedNavigations.some(navigations => navigations?.breadcrumbType === BreadcrumbType.Az)) {
			this.componentScrollService.resetAzValues();
		}

		if (!cachedNavigations.some(navigations => navigations?.breadcrumbType === BreadcrumbType.Category)) {
			this.componentScrollService.resetCategoryValues();
		}

		if (!cachedNavigations.some(navigations => navigations?.breadcrumbType === BreadcrumbType.Search)) {
			this.componentScrollService.resetSearchResultValues();
		}

		if (!cachedNavigations.some(navigations => navigations?.breadcrumbType === BreadcrumbType.InternationalCatalogs)) {
			this.componentScrollService.resetInternationalCatalogsValues();
		}

		this.breadcrumbs.push(
			this.breadCrumbService.getCatalog(
				this.catalog.title,
				this.catalogKey
			)
		);
	}

	public get isSearchEmpty() {
		return this.searchbarService?.searchTerm === ""
	}

	public isTagSelected(tags?: TagModel[]): boolean {
		const selectedTags = tags ?? this.selectedTags;
		return selectedTags.length > 0;
	}

	public async openNews(newsId: number) {
		const component = (await import('../../catalog/news-content/news-content.component')).NewsContentComponent
		const news = this.modalService.open(component,
			{
				centered: true,
				windowClass: `popup`,
				backdropClass: 'popup-backdrop',
				modalDialogClass: 'modal-nobreak-big',
				size: 'xl',
			}
		)
		news.componentInstance.catalog = this.catalog;
		news.componentInstance.catalogKey = this.catalogKey
		news.componentInstance.currentViewType = ViewType.Desktop;
		news.componentInstance.id = newsId;
		news.componentInstance.close.subscribe(() => news.close());
	}

	public get isSearching() {
		return this.searchResultService.isSearching();
	}

	public toggleDetailsSize() {
		this.minimizedDetails = !this.minimizedDetails;
	}

}

